<template>
    <div class="dealTable">
        <!--<unicon name="external-link-alt" fill="#d0d4da"></unicon>-->
        <div v-if="displayColumns.length > 0" class="section">
            <ada-button class="columnButton" title="Spalten verwalten" @click="showColumnSettings = true"></ada-button>
            <ada-table data="getDeals" :columns="displayColumns" :preset="currentPreset"
                       @rowClicked="$emit('rowClicked', $event)" :transformers="transformers"></ada-table>
        </div>
        <column-settings-dialog :show="showColumnSettings" @close="showColumnSettings = false"></column-settings-dialog>
    </div>
</template>

<script>
import ColumnSettingsDialog from "./dialogs/ColumnSettingsDialog";
import AdaButton from "../components/buttons/AdaButton";
import AdaTable from "../components/dataTable/AdaTable";
import moment from "moment";

export default {
    name: "DealTable",
    components: {AdaTable, AdaButton, ColumnSettingsDialog},
    data() {
        return {
            showColumnSettings: false,
            displayColumns: [],
            transformers: [
                {
                    propName: 'action',
                    transform: function (value) {
                        let href = location.origin + '/#/deals/' + value + '?start=' + moment().subtract(14, 'd').format('YYYY-MM-DD')
                            + '&end=' + moment().subtract(1, 'd').format('YYYY-MM-DD');
                        return '<a style="display:inline" href="' + href + '">' +
                            '<div style="display: inline;position: relative;left: 8px;" class="unicorn">' +
                            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#52626e">' +
                            '<path d="M18,10.82a1,1,0,0,0-1,1V19a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V8A1,1,0,0,1,5,7h7.18a1,' +
                            '1,0,0,0,0-2H5A3,3,0,0,0,2,8V19a3,3,0,0,0,3,3H16a3,3,0,0,0,3-3V11.82A1,1,0,0,0,18,' +
                            '10.82Zm3.92-8.2a1,1,0,0,0-.54-.54A1,1,0,0,0,21,2H15a1,1,0,0,0,0,2h3.59L8.29,14.29a1,' +
                            '1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,5.41V9a1,1,0,0,0,2,0V3A1,1,0,0,0,21.92,2.62Z">' +
                            '</path></svg></div></a>';
                    }
                },
            ]
        }
    },
    mounted() {
        if (this.storedColumns.length > 0) {
            this.fetchColumns();
        }
        this.$root.$on('reloadDeals', this.fetchColumns);
        this.$root.$on('columnsLoaded', this.fetchColumns);
    },
    beforeDestroy() {
        this.$root.$off('reloadDeals', this.fetchColumns);
        this.$root.$off('columnsLoaded', this.fetchColumns);
    },
    methods: {
        fetchColumns() {
            let ret = this.$store.getters['columns/columns'];
            let cols = [];
            for (let i = 0; i < ret.length; i++) {
                cols.push({
                    label: ret[i]['display_name'],
                    name: ret[i]['name']
                });
            }

            if (this.$route.name === 'mydeals' && sessionStorage.getItem('columnSettingsPreset') === null &&
                this.vuexState.currentPreset) {
                this.vuexState.currentPreset.columns.forEach((presetCol) => {
                    if (cols.findIndex(x => x.name === presetCol.name) === -1) {
                        cols.push({
                            label: presetCol.display_name,
                            name: presetCol.name
                        });
                    }
                })
            }
            cols.push({
                label: 'Aktion',
                name: 'action',
                noSort: true,
            })
					cols.splice(1, 0,
						{ label: 'Sek. Status', name: 'sub_status'}
					)
					//add sub_status into cols to second position


            this.displayColumns = cols;
            this.$emit("loadingFinished");
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.presets;
        },
        currentPreset() {
            if (this.vuexState.currentPreset !== null && (this.$route.name !== "deals" || this.$route.name !== "myDeals")) {
                return this.vuexState.currentPreset.id
            }
            return 0;
        },
        storedColumns() {
            return this.$store.getters['columns/columns'];
        },
        currentPresetColumns() {
            return this.vuexState.currentPresetColumns;
        }
    }
}
</script>

<style scoped lang="scss">

.dealTable {
    position: relative;
    cursor: default;
}

.topAction {
    display: inline-block;
    float: right;
    padding-left: 1rem;
}

.icon {
    padding: .9rem;
}

.columnButton {
    position: absolute;
    right: 10px;
    top: 12px;
    z-index: 10;
}

.section {
    display: block;
    margin-bottom: 1rem;
    width: 100%;
    overflow-y: auto;
}

.loader {
    left: 50%;
    top: 50%;
    position: absolute;
}


</style>